import React from 'react'
import { i18nTranslate } from 'src/utils'
import './styles.scss'

const ServiceErrorUI = () => {
  return (
    <h4 className="text-center service-failure">
      {i18nTranslate(
        'error.tryAgain',
        'Sorry, something went wrong. Please try again.'
      )}
    </h4>
  )
}

export { ServiceErrorUI }
